import { render } from "./mainlayout.vue?vue&type=template&id=3321bbca"
import script from "./mainlayout.vue?vue&type=script&lang=js"
export * from "./mainlayout.vue?vue&type=script&lang=js"

import "./mainlayout.vue?vue&type=style&index=0&id=3321bbca&lang=css"

import exportComponent from "D:\\project\\idbrand\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__